<script setup>
import $ from 'jquery';
import { v4 as uuidv4 } from 'uuid';
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';

import DsIconButton from 'JIX/components/ds/DsIconButton.vue';

const props = defineProps({
    header: {
        type: String,
        required: true,
    },
    headerLevel: {
        type: Number,
        required: true,
        validator: (x) => [1, 2, 3, 4, 5, 6].includes(x),
    },
    button: {
        type: Object,
        required: false,
        default: null,
    },
});

defineEmits(['buttonClick']);

const buttonElement = ref();
const dropdownContainer = ref();

onMounted(() => {
    if (props.button?.dropdown) {
        $(buttonElement.value.$el).dropdown(props.button.dropdown.options);
    }
});
onBeforeUnmount(() => {
    if (props.button?.dropdown) {
        $(buttonElement.value.$el).dropdown('dispose');
    }
});

const buttonDropdownAttrs = computed(() => {
    const res = {};
    if (props.button.dropdown) {
        res['data-toggle'] = "dropdown";
        res['aria-haspopup'] = "true";
        res['aria-expanded'] = "false";
        res['id'] = 'ds-section-divider-button--' + uuidv4();
    }
    return res;
});
</script>

<template>
    <div class="jix-section-divider">
        <div class="jix-section-divider__inner">
            <Component class="jix-section-divider__header" :is="'h' + headerLevel">
                {{ header }}
            </Component>
            <div class="btn-wrapper-y">
                <div :class="{ 'dropdown': !!button?.dropdown } " ref="dropdownContainer">
                    <DsIconButton
                        type="secondary"
                        size="md"
                        :icon-name="button.icon"
                        :label="button.label"
                        :href="button.href"
                        @click="$emit('buttonClick')"
                        v-if="button"
                        v-bind="buttonDropdownAttrs"
                        ref="buttonElement"
                    />
                    <div class="dropdown-menu dropdown-menu-right" v-if="button?.dropdown" :aria-labelledby="buttonDropdownAttrs.id">
                        <Component
                            :href="item.url"
                            v-on="item.onclick ? { click: item.onclick } : {}"
                            v-for="item in button.dropdown.items"
                            :key="item.key || item.label"
                            :class="['dropdown-item', { active: item.active, 'text-danger': item.danger }]"
                            :is="item.url ? 'a' : 'button'"
                            :target="item.target"
                        >
                            {{ item.label }}
                        </Component>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
